import React, { useState } from 'react';
import './ContactForm.css';
import { useNavigate } from 'react-router-dom';
import { isEmail, isEmpty } from '../utils/formValidator';
import { makePostRequest } from '../services/httpHelper';
import ErrorHandler from '../services/ErrorHandler';
import { CircularProgress } from '@mui/material';
import { Helmet } from "react-helmet-async";

const ContactForm = () => {
  const church = JSON.parse(localStorage.getItem('church'));

  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [values, setValues] = useState({
    name: '',
    email: '',
    message: '',
    subject: '',
    phone: ''
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value
    });
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    setServerError(null);
    setIsSubmitting(true);
    setErrors({});

    const validationErrors = {};

    if (isEmpty(values.name)) validationErrors.name = 'Enter your full name';
    if (values.name.length < 5) validationErrors.name = 'Name is too short';
    if (isEmpty(values.email)) validationErrors.email = 'Enter your email address';
    if (!isEmail(values.email)) validationErrors.email = 'Invalid Email Address';
    if (isEmpty(values.subject)) validationErrors.subject = 'Please enter subject';
    if (isEmpty(values.message)) validationErrors.message = 'Enter your message';
    if (values.message.length < 10) validationErrors.message = 'Message is too short';

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length !== 0) {
      setIsSubmitting(false);
      return;
    }

    const data = {
      contactName: values.name,
      email: values.email,
      phone: values.phone,
      message: values.message,
      subject: values.subject,
      churchEmail: church.email
    };

   try{
    const res = await makePostRequest('contact-us', data);
    if (res && res.errorType) {
      setIsSubmitting(false);
      const errorMessage = ErrorHandler(res);
      setServerError(errorMessage);
    } else {
      setIsSubmitting(false);
      setServerError(null);
      setSubmitted(true);
      //navigate(`/contact-us-success/${values.name}`);
    }

   }catch(error){
    setIsSubmitting(false);
    console.log(error)
   }
  };

  return (
    <>
      <Helmet>
        <meta name="description" content="Please complete the form and send. We will be happy hearing from you and we will get back to you as soon as possible." />
        <link rel="canonical" href="/contact-us" />
      </Helmet>

      <section id="contact">
        <div className="contact-box">
          <div className="contact-links">
            <h2>CONTACT {church.church_name.toUpperCase()}</h2>
            <p>Thank you for choosing to reach out to us. Please complete the form to send message to us. We will be happy hearing from you and we will get back to you as soon as possible.</p>
          </div>
          <div className="contact-form-wrapper">
            {isSubmitting && <CircularProgress />}
            {serverError !== null && <p className='text text-danger'>{serverError}</p>}
            {submitted && navigate(`/contact-us-success/${values.name}`)}
            {submitted && <p className='text text-success'>Your message have been send!</p>}

            <form onSubmit={sendMessage}>
              <div className="form-item">
                <input type="text" name="name" value={values.name} onChange={handleChange} required />
                <label>Name:</label>
                {errors.name && <p className='text text-danger'>{errors.name}</p>}
              </div>

              <div className="form-item">
                <input type="email" name="email" value={values.email} onChange={handleChange} required />
                <label>Email:</label>
                {errors.email && <p className='text text-danger'>{errors.email}</p>}
              </div>

              <div className="form-item">
                <input type="tel" name="phone" value={values.phone} onChange={handleChange} />
                <label>Phone Number:</label>
                {errors.phone && <p className='text text-danger'>{errors.phone}</p>}
              </div>

              <div className="form-item">
                <input type="text" name="subject" value={values.subject} onChange={handleChange} placeholder='subject' required />
                <label>Subject:</label>
                {errors.subject && <p className='text text-danger'>{errors.subject}</p>}
              </div>

              <div className="form-item">
                <textarea name="message" value={values.message} onChange={handleChange} required rows={10}></textarea>
                <label>Message:</label>
                {errors.message && <p className='text text-danger'>{errors.message}</p>}
              </div>

              <button type='submit' className="submit-btn">
                {isSubmitting ? <CircularProgress /> : 'Send'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactForm;
